import crypto from 'crypto-browserify'
import { algorithm } from './algorithm'

// Cache para evitar recalcular la key en cada uso
let cachedKey = null

const decryptEnvPassword = (text, codePassword) => {
  const encryptedArray = text.split(':')
  if (!encryptedArray[1]) {
    throw new Error('IV is missing in hash')
  }
  const iv = Buffer.from(encryptedArray[0], 'hex')
  const encrypted = Buffer.from(encryptedArray[1], 'hex')
  const decipher = crypto.createDecipheriv(algorithm, codePassword, iv)
  const decrypted = decipher.update(encrypted)
  return Buffer.concat([decrypted, decipher.final()]).toString()
}

// Versión síncrona (mantenida para compatibilidad)
export const key = () => {
  if (cachedKey) return cachedKey

  const codePassword = Buffer.from(
    'Ls2HjdWL4/X/5t6WmgN3C6URMzVd7o1Y3wFvzKkbOkQ=',
    'base64',
  )
  const envPassword = process.env.REACT_APP_ENCRYPTED_PASSWORD

  if (!envPassword) {
    throw new Error('REACT_APP_ENCRYPTED_PASSWORD no está definido')
  }

  const password = Buffer.from(decryptEnvPassword(envPassword, codePassword), 'base64')
  const salt = Buffer.from(
    'vKSkROxGl6tiILfLdUQqQFu31sQ75rq17vHdjikNvrc=',
    'base64',
  )

  cachedKey = crypto.pbkdf2Sync(password, salt, 100000, 32, 'sha512')
  return cachedKey
}

// Versión asíncrona (no bloquea el UI)
export const keyAsync = () => {
  return new Promise((resolve, reject) => {
    if (cachedKey) {
      resolve(cachedKey)
      return
    }

    const codePassword = Buffer.from(
      'Ls2HjdWL4/X/5t6WmgN3C6URMzVd7o1Y3wFvzKkbOkQ=',
      'base64',
    )
    const envPassword = process.env.REACT_APP_ENCRYPTED_PASSWORD

    if (!envPassword) {
      reject(new Error('REACT_APP_ENCRYPTED_PASSWORD no está definido'))
      return
    }

    const password = Buffer.from(decryptEnvPassword(envPassword, codePassword), 'base64')
    const salt = Buffer.from(
      'vKSkROxGl6tiILfLdUQqQFu31sQ75rq17vHdjikNvrc=',
      'base64',
    )

    crypto.pbkdf2(password, salt, 100000, 32, 'sha512', (err, derivedKey) => {
      if (err) {
        reject(err)
      } else {
        cachedKey = derivedKey
        resolve(derivedKey)
      }
    })
  })
}

// Pre-calcular la key al cargar el módulo (en background)
setTimeout(() => {
  keyAsync().catch(console.error)
}, 0)

